import api from './api';

export const getAllQuestions = async () => {
  const response = await api.get('/questions');
  // console.log(`response = get('/questions'): `, response.data);
  return response.data.data;
};

export const getQuestionById = async (id) => {
  const response = await api.get(`/questions/${id}`);
  return response.data;
};

export const createQuestion = async (formData) => {
    // console.log('createQuestion formData:', formData);
    // for (let [key, value] of formData.entries()) {
    //   console.log(`formData ${key}:`, value);
    // }
    const response = await api.post('/questions', formData);
    // console.log('response.data:', response.data);

  return response.data;
};

export const updateQuestion = async (id, formData) => {
    // console.log('updateQuestion formData:', formData);
  const response = await api.put(`/questions/${id}`, formData);
  return response.data;
};

export const deleteQuestion = async (id) => {
  const response = await api.delete(`/questions/${id}`);
  return response.data;
};

// export const indentInsertQuestion = async (data) => {
//   const response = await api.post(`/questions/indent`, data);
//   return response.data;
// };

export const deleteReindexQuestion = async (path) => {
  const response = await api.delete(`/questions/reindex/${path}`);
  return response.data;
};

export const reindexAllQuestions = async () => {
  const response = await api.post(`/questions/reindexAll`);
  return response.data;
};

export const indentInsertQuestion = async (payload) => {
  // payload: { parentPath, insertAt, description, parent_id, mode }
  const res = await api.post("/questions/indent-insert", payload);
  return res.data;
};
